// Маска +998 и 9 цифр (как в доставке)
import React from 'react';

export function digitsUz9(value) {
  return String(value || '')
    .replace(/\+998/g, '')
    .replace(/\D/g, '')
    .slice(0, 9);
}

export function isValidUz9(value) {
  return digitsUz9(value).length === 9;
}

export default function UzPhoneField({ value, onChange, error }) {
  const digits = digitsUz9(value);

  const handleChange = (e) => {
    const clean = e.target.value.replace(/\D/g, '').slice(0, 9);
    onChange('+998' + clean);
  };

  const formatted = digits
    .replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4')
    .replace(/(\d{2})(\d{3})(\d{2})/, '$1 $2 $3')
    .replace(/(\d{2})(\d{3})/, '$1 $2')
    .replace(/(\d{2})/, '$1');

  const isValid = digits.length === 9;
  const isEmpty = digits.length === 0;

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          border: `1.5px solid ${
            error ? '#E85D4A' : isValid ? '#4CAF50' : '#E0E0E0'
          }`,
          borderRadius: '12px',
          overflow: 'hidden',
          backgroundColor: '#FAFAFA',
          transition: 'border-color 0.2s',
        }}
      >
        <div
          style={{
            padding: '12px 10px 12px 14px',
            fontSize: '15px',
            color: '#333',
            fontWeight: '600',
            backgroundColor: '#F0F0F0',
            borderRight: '1px solid #E0E0E0',
            whiteSpace: 'nowrap',
            userSelect: 'none',
          }}
        >
          🇺🇿 +998
        </div>
        <input
          type="tel"
          inputMode="numeric"
          autoComplete="tel-national"
          style={{
            flex: 1,
            padding: '12px 14px',
            border: 'none',
            outline: 'none',
            fontSize: '15px',
            backgroundColor: 'transparent',
            fontFamily: 'inherit',
            letterSpacing: '1px',
          }}
          placeholder="90 123 45 67"
          value={formatted}
          onChange={handleChange}
        />
        {!isEmpty && (
          <div
            style={{
              padding: '12px',
              fontSize: '18px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {isValid ? '✅' : '⚠️'}
          </div>
        )}
      </div>
      {error && (
        <div style={{ fontSize: '12px', color: '#E85D4A', marginTop: '4px' }}>{error}</div>
      )}
    </div>
  );
}
